module.exports = __webpack_public_path__ + "img/vice-chairman-img.5599109f.jpg";